module.exports = __webpack_public_path__ + "static/organic-search-row-ten-hero-500d68bee705ab47a2517a0edeca4e10.png";